<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn outline color="green" @click="showAddModal">
          <em class="fas fa-plus mr-2" />Add Customer</v-btn
        >
        <v-btn @click="onClickUploadButton" outline color="blue">
          <em class="fas fa-file-upload mr-2" />Import</v-btn
        >
        <input
          type="file"
          :key="`file__${keyupload}`"
          class="form-control-file pt-2"
          name="csvUploadCentralHr"
          :id="'csvUploadCentralHr'"
          data-vv-as="File"
          v-validate="'mimes:text/xlsx'"
          accept=".xlsx"
          @input="onFileChange($event)"
          style="
            overflow: hidden;
            position: fixed;
            width: 1px;
            height: 1px;
            z-index: -1;
            opacity: 0;
          "
        />
        <v-btn outline color="orange" @click="exportCustomer">
          <em class="fas fa-file-import mr-2" />Export</v-btn
        >
        <v-btn outline color="grey" @click="showSearch = true">
          <v-icon>search</v-icon>Search</v-btn
        >
      </div>

      <div class="text-xs-center" v-if="loadingTotal">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <v-layout v-else>
        <v-flex style="font-weight: 600">
          <div>All Points Available</div>
          <span style="color: pink; font-size: 23px">
            {{ summary.all_points_available | numberFormat }}
          </span>
        </v-flex>
        <v-flex style="font-weight: 600">
          <div>All Points Usage</div>
          <span style="color: pink; font-size: 23px">
            {{ summary.all_points_usage | numberFormat }}
          </span>
        </v-flex>
        <v-flex style="font-weight: 600">
          <div>All Total Points</div>
          <span style="color: pink; font-size: 23px">
            {{ summary.all_total_points | numberFormat }}
          </span>
        </v-flex>
      </v-layout>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :pagination.sync="pagination"
        :items="filterCustomers"
        class="elevation-1"
        :total-items="total"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.account_no }}</td>
          <td style="white-space: nowrap">
            {{ props.item.prefix_th + props.item.name_th + ' ' + props.item.surname_th }}
          </td>
          <td style="white-space: nowrap">
            {{ props.item.prefix_en + props.item.name_en + ' ' + props.item.surname_en }}
          </td>
          <td>{{ props.item.points_available }}</td>
          <td>{{ props.item.points_usage }}</td>
          <td>{{ props.item.total_points }}</td>

          <td class="text-xs-right">
            <div>
              <v-btn @click="showEditModal(props.item)" icon>
                <v-icon color="grey">edit</v-icon>
              </v-btn>
              <v-btn @click="deleteCustomer(props.item)" icon>
                <v-icon color="grey">delete</v-icon>
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <div>
      <v-dialog v-model="showEdit" width="900px" persistent>
        <v-card>
          <CustomerEdit
            @closeEdit="showEdit = false"
            @onEdit="onEdit"
            :type="edittype"
            v-if="showEdit"
            :editdata="editdata"
          ></CustomerEdit>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="showSearch" width="900px" persistent>
      <v-card>
        <v-card-text>
          <div class="form-control">
            <div class="caption">{{ $t('ID card/Passport') }}</div>
            <input type="text" v-model="input.idcard" />
          </div>
          <div class="form-control">
            <div class="caption">{{ $t('ชื่อ นามสกุล') }}</div>
            <input type="text" v-model="input.name" />
          </div>
          <div class="form-control">
            <div class="caption">{{ $t('Tel.') }}</div>
            <input type="tel" v-model="input.tel" />
          </div>
          <div class="form-control">
            <div class="caption">{{ $t('Email') }}</div>
            <input type="email" v-model="input.email" />
          </div>
          <div class="form-control">
            <div class="caption">{{ $t('Account No.') }}</div>
            <input type="text" v-model="input.account_no" />
          </div>
        </v-card-text>

        <div class="text-xs-center">
          <v-btn outline color="gray" @click="clearAll">{{ $t('clear all') }}</v-btn>
          <v-btn depressed color="primary" @click="onSearch">{{ $t('Search') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large>folder_shared</v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ total_customer | numberFormat }}
                    </template>
                    <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                  </div>

                  <v-btn small color="primary" depressed @click="exportCustomerByPage(page)">
                    download
                  </v-btn>
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomerEdit from './CustomerEdit.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import pickBy from 'lodash/pickBy'
export default {
  components: {
    CustomerEdit
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filterCustomers() {
      return this.data
    }
  },
  data() {
    return {
      keyupload: 0,
      edittype: '',
      editdata: {},
      showEdit: false,
      loading: false,
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 20
      },
      input: {
        idcard: '',
        name: '',
        tel: '',
        email: '',
        account_no: ''
      },
      summary: {
        all_points_available: 0,
        all_points_usage: 0,
        all_total_points: 0
      },
      headers: [
        { text: 'Account No.', value: 'account_no' },
        { text: 'Name(th)', value: 'name_th', sortable: false },
        { text: 'Name(en)', value: 'name_en', sortable: false },
        { text: 'Current Points', value: 'points_available', sortable: false },
        { text: 'Used Points', value: 'points_usage', sortable: false },
        { text: 'Total Points', value: 'total_points', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      data: [],
      showSearch: false,
      search: null,
      offset: 0,
      limit: 100,
      total: 0,
      showExport: false,
      exportpagecount: 0,
      exportlimit: 1000,
      total_customer: 0,
      loadingTotal: true
    }
  },
  async mounted() {
    this.getData()

    await this.loadTotal()
  },
  methods: {
    async loadTotal() {
      this.loadingTotal = true
      try {
        var { all_points_available, all_points_usage, all_total_points } =
          await this.mjdallpointscustomerdashboard()
        this.summary = {
          all_points_available: all_points_available,
          all_points_usage: all_points_usage,
          all_total_points: all_total_points
        }
      } catch (error) {
        this.summary = {
          all_points_available: 0,
          all_points_usage: 0,
          all_total_points: 0
        }
      }

      this.loadingTotal = false
    },
    clearAll() {
      this.search = null
      this.input = {
        idcard: '',
        name: '',
        tel: '',
        email: '',
        account_no: ''
      }
      this.onSearch()
    },
    onSearch() {
      this.search = cloneDeep(this.input)
      this.getData()
      this.showSearch = false
    },
    async exportCustomerByPage(page) {
      var response = await this.getExportData(page, this.exportlimit)
      var data = response.data

      var json = data.map((el) => {
        return {
          'Account No.': el.account_no,
          'RMS-Account': el.rms_account,
          PrefixThai: el.prefix_th || 'คุณ',
          PrefixEng: el.prefix_en || 'Khun.',
          NameThai: el.name_th,
          SurnameThai: el.surname_th,
          NameEng: el.name_en,
          SurnameEng: el.surname_en,
          Gender: el.gender,
          'Mobile#1': el.mobile_1 ? el.mobile_1 : '-',
          'Mobile#2': el.mobile_2 ? el.mobile_2 : '-',
          'E-Mail#1': el.email_1,
          'E-Mail#2': el.email_2,
          'Birthday(dd-mm-yyyy)': el.birthday ? moment(el.birthday).format('DD-MM-YYYY') : '',
          AccountStatus: el.account_status,
          'ID CARD / Passport': el.id_card,
          'T/E': el.t_e,
          ProjectName: el.project_name,
          Floor: el.floor,
          'Unit No.': el.unit_no,
          Area: el.area,
          Point: el.point,
          'Used Point': el.points_usage,
          'Current Point': el.points_available,
          Group: el.group,
          LineID: el.lineid
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      // XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

      XLSX.writeFile(wb, 'mjd-customer.xlsx')
    },
    async exportCustomer() {
      var data = await this.getExportData(1, this.exportlimit)
      this.total_customer = data.total
      this.exportpagecount = Math.ceil(this.total_customer / this.exportlimit)
      this.showExport = true
    },
    onEdit() {
      this.getData()
      this.showEdit = false
    },
    showEditModal(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.showEdit = true
    },
    showAddModal() {
      this.edittype = 'add'
      this.editdata = null
      this.showEdit = true
    },
    deleteCustomer(item, k) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ต้องการลบใช่หรือไม่?',
          showCancelButton: true
          // reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.$store.state.loading = true
            api.deletemjdcustomerdashboard(
              { pageid: this.selectedBot.pageid, account_no: item.account_no },
              (err, response) => {
                this.$store.state.loading = false
                if (response.responsecode == 200) {
                  this.data.splice(
                    this.data.findIndex((el) => el.account_no == item.account_no),
                    1
                  )
                }
              }
            )
          }
        })
    },
    getData() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      const input = pickBy(this.input, function (value, key) {
        return !(value === undefined || value === null || value === '')
      })

      var data = {
        pageid: this.selectedBot.pageid,
        ...input,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        orderby: sortBy == 'account_no' && descending != true ? 'asc' : 'desc'
      }
      this.loading = true
      api.getmjdcustomerdashboard(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var data = response.data
          if (this.pagination.sortBy) {
            data = data.sort((a, b) => {
              const sortA = a[sortBy]
              const sortB = b[sortBy]

              if (descending) {
                if (sortA < sortB) return 1
                if (sortA > sortB) return -1
                return 0
              } else {
                if (sortA < sortB) return -1
                if (sortA > sortB) return 1
                return 0
              }
            })
          }
          this.data = data

          this.total = parseInt(response.count)
          this.loadTotal()
        }
      })
    },
    mjdallpointscustomerdashboard() {
      return new Promise((resolve, reject) => {
        api.mjdallpointscustomerdashboard(
          { pageid: this.selectedBot.pageid },
          (error, response) => {
            if (error) reject(error)
            resolve(response)
          }
        )
      })
    },
    getExportData(page, rowsPerPage) {
      const input = pickBy(this.input, function (value) {
        return !(value === undefined || value === null || value === '')
      })
      const data = {
        pageid: this.selectedBot.pageid,
        ...input,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage
      }
      this.loading = true
      return new Promise((resolve, reject) => {
        api.getmjdexportcustomerdashboard(data, (err, response) => {
          this.loading = false
          if (err) reject()
          if (response.responsecode == 200) {
            resolve({
              data: response.data,
              total: parseInt(response.count)
            })
          } else {
            reject()
          }
        })
      })
    },
    onClickUploadButton() {
      document.getElementById('csvUploadCentralHr').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array', cellDates: true })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          var jsonresult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
          jsonresult = jsonresult.map((obj) => {
            var objdata = obj
            for (const [key, value] of Object.entries(objdata)) {
              if (typeof value.getMonth === 'function') {
                objdata[key] = moment(value).add(7, 'hours').format('DD-MM-YYYY')
              }
            }
            return objdata

            // if(typeof el[key].getMonth === 'function') {

            // } else {

            // }
          })
          result.push(vm.trimObj(jsonresult))
        }

        vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      // console.log(obj)
      var result = Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )

      return result
    },
    uploadExcel(file) {
      var vm = this
      if (file && file.length) {
        var filteredFile = file[0]
          .filter((el) => {
            return (
              el['Account No.'] &&
              el['PrefixThai'] &&
              el['PrefixEng'] &&
              el['NameThai'] &&
              el['SurnameThai'] &&
              el['NameEng'] &&
              el['SurnameEng'] &&
              el['ID CARD / Passport'] &&
              el['ProjectName'] &&
              el['Floor'] &&
              el['Unit No.']
            )
          })
          .map((el) => {
            return {
              ...el,
              'Birthday(dd-mm-yyyy)': el['Birthday(dd-mm-yyyy)']
                ? moment(el['Birthday(dd-mm-yyyy)'], 'DD-MM-YYYY').format('DD-MM-YYYY')
                : ''
            }
          })

        if (filteredFile && filteredFile.length) {
          var data = {
            pageid: vm.selectedBot.pageid,
            files: [filteredFile]
          }
          api.postmjdimportaccounts(data, (error, response) => {
            if (error) {
              console.error(error)
            } else {
              if (response.responsecode == 200) {
                vm.$swal.fire({
                  text: 'สำเร็จ'
                })
                vm.keyupload++
                vm.getData()
              } else {
                vm.$swal.fire({
                  text: 'สำเร็จ'
                })
              }
            }
          })
        } else {
          this.$swal.fire({
            text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
          })
          this.loading = false
        }
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/Customer.vue